module.exports = __webpack_public_path__ + "img/rule-ms.03c4b66e.png";